<template>
  <div
    id="starrysky"
    class="sky"
    @click="toggleFullScreen"
  >
    <button>
      <h1>
        <v-icon class="title mdi-spin">
          mdi-star
        </v-icon>
      </h1>
    </button>
    <div class="layer1" />
    <div class="layer2" />
    <div class="layer3" />
    <div class="layer4" />
    <div class="layer5" />
    <div class="layer6" />
  </div>
</template>

<script>
// import './css/index.sass'

export default {

  methods: {
    toggleFullScreen() {
      const el = document.getElementById('starrysky')
      if (!el.fullscreenElement) {
        el.requestFullscreen()
        document.exitFullscreen()
      } else {
        document.exitFullscreen()
      }
    }
  },
}
</script>

<style lang="sass" scoped>
// <!-- 银色灰色渐变从上到下，全屏居中 -->
.title
    font-family: 'Dancing Script', cursive
    font-size: 50px
    color: #fff
    // 阴影
    text-shadow: 0 0 10px rgba(242, 232, 234, 0.9)
    background-color: linear-gradient(to bottom, #white, #000)
    background-clip: text
    -webkit-background-clip: text
    text-align: center
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    // color: transparent
.sky
    width: 100%
    height: 100%
    background-color: #000

@function getShadows($n)
    $shadow: ()
    @for $i from 1 through $n
        $shadow: append($shadow, unquote('#{random(100)}vw') unquote('#{random(100)}vh') #fff, comma)
    @return $shadow

$duration: 1000s
$count: 1000
@for $i from 1 through 6
  $duration: floor($duration / 2)
  $count: floor($count / 2)
  .layer#{$i}
      position: fixed
      $size: #{$i}px
      width: $size
      height: $size
      border-radius: 50%
      // background-color: red
      box-shadow: getShadows($count)
      animation: moveup $duration linear infinite
      &::after
          content: ''
          position: fixed
          width: inherit
          height: inherit
          left: 0
          top: 100vh
          box-shadow: inherit
          border-radius: inherit

@keyframes moveup
    to
        transform: translateY(-100vh)

</style>